import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import { permissionKeys } from "@/utility/helper";
import type { IPrivateRoutes } from "../types";

const Payslip = lazy(() => import("@/pages/HRMS/Payslip/Payslip"));
const TeamsPayslip = lazy(() => import("@/pages/HRMS/Payslip/TeamsPayslip"));
const BranchUsersPayslip = lazy(() => import("@/pages/HRMS/Payslip/BranchUsersPayslip"));
const SalaryHead = lazy(() => import("@/pages/HRMS/SalaryHead/SalaryHead"));
const AddSalaryHead = lazy(() => import("@/pages/HRMS/SalaryHead/AddSalaryHead"));
const ViewSalaryHead = lazy(() => import("@/pages/HRMS/SalaryHead/ViewSalaryHead"));
const OfficeSalaryHead = lazy(() => import("@/pages/HRMS/OfficeSalaryHead/BrachSalaryHead"));
const AddOfficeSalaryHead = lazy(() => import("@/pages/HRMS/OfficeSalaryHead/AddBrachSalaryHead"));
const CreateSalary = lazy(() => import("@/pages/HRMS/CreateSalary/CreateSalary"));
const BranchSalaryConfig = lazy(() => import("@/pages/HRMS/HrmsSettings/BranchSalaryBackupsConfig/BranchSalaryConfig"));

export const payrollRoutes: IPrivateRoutes[] = [
    // Payslip
    {
        path: RoutesLink.payslip,
        route: <Payslip />,
        accessKey: permissionKeys.payslip,
    },
    {
        path: RoutesLink.teamsPayslip,
        route: <TeamsPayslip />,
        accessKey: permissionKeys.payslip,
        teamAccess: true,
    },
    {
        path: `${RoutesLink.branchUserPayslip}/:id`,
        route: <BranchUsersPayslip />,
        accessKey: permissionKeys.payslip,
        teamAccess: true,
    },

    // Salary Head
    {
        path: RoutesLink.salaryHead,
        route: <SalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: RoutesLink.addSalaryHead,
        route: <AddSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.editSalaryHead}/:id`,
        route: <AddSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.SalaryHeadDetails}/:id`,
        route: <ViewSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },

    // Office / Branch Salary Head
    {
        path: RoutesLink.branchSalaryHead,
        route: <OfficeSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: RoutesLink.addBranchSalaryHead,
        route: <AddOfficeSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.editBranchSalaryHead}/:id`,
        route: <AddOfficeSalaryHead />,
        accessKey: permissionKeys.hrmSetting,
    },

    // Create Salary
    {
        path: RoutesLink.createSalary,
        route: <CreateSalary />,
        accessKey: permissionKeys.hrmSetting,
    },

    // Branch Salary Backup
    {
        path: RoutesLink.branchSalaryBackup,
        route: <BranchSalaryConfig />,
        accessKey: permissionKeys.hrmSetting,
    },
];
